<template>
  <div class="courseSystemContainer">
    <div class="header">
      <div class="title">课程体系</div>
      <div class="headerImg">
        <div class="imgContent">
          <SvgIcon icon-class="iconicon1"></SvgIcon>
        </div>
      </div>
    </div>
    <div class="courseSystemInfo">
      <div class="infoTitle">{{specialtyName}}专业课程体系</div>
      <div class="infoContent">
        <div class="contentItem" @click="showOrHide(Math.ceil(item.courses.length/3), index)" v-for="(item, index) in courseSystemData" :key="index">
          <div class="title">
            <div class="img"></div>
            <span>{{item.term}}</span>
            <van-icon name="arrow-down" />
          </div>
          <div class="content" style="height: 0;padding-bottom: 0;">
            <div class="item" v-for="(course, i) in item.courses" :key="i" @click.stop="syllabus(course)">{{course.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <back-to :path="'/'"></back-to>
  </div>
</template>
<script>
import api from '@/api'
import backTo from '@/components/back'
import { Icon } from 'vant'
export default {
  components: { backTo, [Icon.name]: Icon },
  data() {
    return {
      courseSystemData: [],
      specialtyName: ''
    }
  },
  created() {
    this.getInfo()
    this.specialtyName = JSON.parse(localStorage.getItem('userInfo')).specialtyName
  },
  methods: {
    getInfo() {
      this.$get(api.courseSystem.list(), { versionId: JSON.parse(localStorage.getItem('userInfo')).versionId }).then(res => {
        let tmpArr = [
          {
            term: '第一学期',
            courses: []
          },
          {
            term: '第二学期',
            courses: []
          },
          {
            term: '第三学期',
            courses: []
          },
          {
            term: '第四学期',
            courses: []
          },
          {
            term: '第五学期',
            courses: []
          },
          {
            term: '第六学期',
            courses: []
          },
          {
            term: '第七学期',
            courses: []
          },
          {
            term: '第八学期',
            courses: []
          }
        ]
        for (let i = 0; i < res.courses.length; i++) {
          let item = res.courses[i];
          tmpArr[item.term - 1].courses.push(item)
        }
        this.courseSystemData = tmpArr
      })
    },
    showOrHide(height, index) {
      index = index + 1
      if(document.querySelector('.infoContent>div:nth-of-type('+index+')>.content').style.height === '0px') {
        document.querySelector('.infoContent>div:nth-of-type('+index+')>.content').style.height = (height * 70 + 60 + height * 20) / (750 / document.querySelector('.courseSystemContainer').clientWidth) + 'px'
        document.querySelector('.infoContent>div:nth-of-type('+index+')>.content').style.paddingBottom = '40px'
        document.querySelector('.infoContent>div:nth-of-type('+index+')>.title>i').style.transform = 'rotate(-180deg)'
      } else {
        document.querySelector('.infoContent>div:nth-of-type('+index+')>.content').style.height = 0 + 'px'
        document.querySelector('.infoContent>div:nth-of-type('+index+')>.content').style.paddingBottom = '0px'
        document.querySelector('.infoContent>div:nth-of-type('+index+')>.title>i').style.transform = 'rotate(0)'
      }
    },
    syllabus(course){
      this.$router.push({
        path: '/syllabus',
        query: {
          from: 1,
          courseId: course.id,
          courseName: course.name
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.courseSystemContainer {
  background-color: #fff;
  .header {
    height: 280px;
    background-image: url('../../assets/bg-biyeyaoqiu.png');
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    .title {
      font-size: 36px;
      font-weight: 700;
      color: #fff;
      text-align: center;
      margin-top: 40px;
      letter-spacing: $letter-spacing;
    }
    .headerImg {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      position: absolute;
      left: 50%;
      bottom: 40px;
      margin-left: -60px;
      background-color: #fff;
      padding: 10px;
      .imgContent {
        width: 100px;
        height: 100px;
        background-color: #E5F7F3;
        border-radius: 50%;
        text-align: center;
        line-height: 123px;
        svg {
          width:58px;
          height:54px;
        }
      }
    }
  }
  .courseSystemInfo{
    .infoTitle {
      font-size: 30px;
      font-weight: 700;
      color: rgba(50,50,50,1);
      letter-spacing: $letter-spacing;
      text-align: center;
    }
    .infoContent {
      padding: 45px 24px;
      .contentItem {
        padding: 40px 40px 0 30px;
        box-shadow: $box-shadow;
        margin-bottom: 30px;
        overflow: hidden;
        .title {
          margin-bottom: 40px;
          .img {
            width: 35px;
            display: inline-block;
            height: 20px;
            background-image: url('../../assets/dian-biaoti.png');
            background-size: 100% 100%;
            margin-right: 20px;
          }
          span {
            font-size:30px;
            font-weight: 500;
            color: #323232;
            letter-spacing: $letter-spacing;
          }
          i {
            transition: all .5s;
            width: 30px;
            float: right;
            margin-top: 5px;
            color: #ddd;
          }
        }
        .content {
          transition: all .5s;
          overflow: hidden;
          width: 100%;
          box-sizing: border-box;
          .item {
            float: left;
            width: 30%;
            height:70px;
            background:#F4F4F4;
            border-radius:10px;
            line-height: 70px;
            text-align: center;
            font-size:24px;
            color: #969696;
            letter-spacing: $letter-spacing;
            margin-bottom: 20px;
            margin: 0 1.6% 20px;
            box-sizing: border-box;
            @include text-ellipsis($line-clamp: 1);
            padding: 0 10px;
          }
        }
      }
    }
  }
}
</style>